/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Invite_TitleInputs */

const cs_portal_invite_title = /** @type {(inputs: Portal_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivace portálu`)
};

const en_portal_invite_title = /** @type {(inputs: Portal_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept portal invite`)
};

/**
* | output |
* | --- |
* | "Accept portal invite" |
*
* @param {Portal_Invite_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_invite_title = /** @type {((inputs?: Portal_Invite_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Invite_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_invite_title(inputs)
	return cs_portal_invite_title(inputs)
});